module.exports = {
  ...require("./src/units"),
  ...require("./src/geofences"),
  ...require("./src/dst"),
  ...require("./src/co2Saved"),
  ...require("./src/address"),
  ...require("./src/hours"),
};
